// @greenlight-spec: 09-data-brokering.md
// @greenlight-spec: 15-database-schema.md#integration_connection_requests
// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// A connection-request asks IT to connect a *catalogued* integration the org has
// not registered. It is not a grant: a grant binds a principal to a credential on
// an integration that already exists, while this asks for the integration itself.
// Connecting a new external source is higher-privilege than widening access to one
// already connected, so there is no `auto` approval mode and no auto-approved path.
export const CONNECTION_REQUEST_STATUSES = ['pending', 'approved', 'denied'];
/**
 * Bounds on the untrusted half of a request. The reason is free text written by a
 * citizen developer's agent and read by IT, so it is capped, stored inert, and
 * never parsed for structure. The rate limit is per requesting user across every
 * surface (MCP, CLI), mirroring the feedback channel's single windowed cap.
 */
export const CONNECTION_REQUEST_CAPS = {
    reasonMaxChars: 2_000,
    decisionNoteMaxChars: 2_000,
    rateLimitMax: 10,
    rateLimitWindowSeconds: 3_600,
};
/**
 * How long an approved request may sit with its integration still unregistered
 * before IT is nudged again. Approving does not connect anything — IT still has to
 * run the Register flow — so this is the one state in the flow that can go quiet
 * forever. A week is long enough that finishing the registration the same week is
 * silent, and short enough that a forgotten approval surfaces while the requester
 * still remembers asking.
 */
export const CONNECTION_REQUEST_REMINDER_WINDOW_DAYS = 7;
//# sourceMappingURL=integration-connection-request.js.map